/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raising the salt concentration or the oligo concentration increases the Tm.`)
};

const es_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar la concentración de sal o la concentración de oligo aumenta la Tm.`)
};

const de_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Erhöhung der Salzkonzentration oder der Oligo-Konzentration erhöht die Tm.`)
};

const nl_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het verhogen van de zoutconcentratie of de oligoconcentratie verhoogt de Tm.`)
};

const fr_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmenter la concentration en sel ou la concentration en oligo augmente la Tm.`)
};

const it_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentare la concentrazione salina o la concentrazione dell'oligo aumenta la Tm.`)
};

const pt_br2_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar a concentração de sal ou a concentração do oligo eleva a Tm.`)
};

const pt_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar a concentração salina ou a concentração de oligo aumenta a Tm.`)
};

const ja_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`塩濃度またはオリゴ濃度を上げるとTmが上昇します。`)
};

const zh_tm_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提高盐浓度或寡核苷酸浓度会使 Tm 升高。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_ex3", locale)
	if (locale === "en") return en_tm_ex3(inputs)
	if (locale === "es") return es_tm_ex3(inputs)
	if (locale === "de") return de_tm_ex3(inputs)
	if (locale === "nl") return nl_tm_ex3(inputs)
	if (locale === "fr") return fr_tm_ex3(inputs)
	if (locale === "it") return it_tm_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_tm_ex3(inputs)
	if (locale === "pt") return pt_tm_ex3(inputs)
	if (locale === "ja") return ja_tm_ex3(inputs)
	return zh_tm_ex3(inputs)
};